import { render, staticRenderFns } from "./RecentlyAddedCategoryContent.vue?vue&type=template&id=c972b3ca&scoped=true&"
import script from "./RecentlyAddedCategoryContent.vue?vue&type=script&lang=js&"
export * from "./RecentlyAddedCategoryContent.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyAddedCategoryContent.vue?vue&type=style&index=0&id=c972b3ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c972b3ca",
  null
  
)

export default component.exports